var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTemplate4Web = function SvgTemplate4Web(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16 4H5.33333C4.59695 4 4 4.59695 4 5.33333V8C4 8.73638 4.59695 9.33333 5.33333 9.33333H16C16.7364 9.33333 17.3333 8.73638 17.3333 8V5.33333C17.3333 4.59695 16.7364 4 16 4Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.9999 4H21.6666C20.9302 4 20.3333 4.59695 20.3333 5.33333V8C20.3333 8.73638 20.9302 9.33333 21.6666 9.33333H26.9999C27.7363 9.33333 28.3333 8.73638 28.3333 8V5.33333C28.3333 4.59695 27.7363 4 26.9999 4Z",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M26.6667 11.332H5.33333C4.59695 11.332 4 11.929 4 12.6654V16.6654C4 17.4017 4.59695 17.9987 5.33333 17.9987H26.6667C27.403 17.9987 28 17.4017 28 16.6654V12.6654C28 11.929 27.403 11.332 26.6667 11.332Z",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13.3333 20H5.33333C4.59695 20 4 20.597 4 21.3333V25.3333C4 26.0697 4.59695 26.6667 5.33333 26.6667H13.3333C14.0697 26.6667 14.6667 26.0697 14.6667 25.3333V21.3333C14.6667 20.597 14.0697 20 13.3333 20Z",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M27.0001 20H19.0001C18.2637 20 17.6667 20.597 17.6667 21.3333V25.3333C17.6667 26.0697 18.2637 26.6667 19.0001 26.6667H27.0001C27.7365 26.6667 28.3334 26.0697 28.3334 25.3333V21.3333C28.3334 20.597 27.7365 20 27.0001 20Z",
    stroke: "currentColor"
  })));
};
export default SvgTemplate4Web;